"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genderizeText = genderizeText;
exports.feminizeText = feminizeText;
exports.masculinizeText = masculinizeText;
const FEMINIZE_BLOCKLIST = new Set([
    'open',
    'team',
    'staff',
    'coffee',
    'sales',
    'marketing',
    'manager',
    'director',
    'leader',
    'designer',
    'developer',
    'engineer',
    'analyst',
    'assistant',
    'specialist',
    'coordinator',
    'consultant',
    'linkedin',
    'github',
    'cv',
    'rh',
    'r&d',
    'développeuse',
    'cheffe',
    'directrice',
    'ingénieure',
    'technicienne',
    'employée',
    'enseignante',
    'salariée',
    'stagiaire',
    'volontaire',
    'bénévole',
    'actrice',
    'chanteuse',
    'auteure',
    'professeure',
    'lycée',
    'université',
    'café',
    'thé',
    'musée',
    'collège',
    'faculté',
    'école',
    'hôpital',
    'maison',
    'association',
]);
const MASCULINIZE_BLOCKLIST = new Set([
    'développeur',
    'chef',
    'directeur',
    'ingénieur',
    'technicien',
    'employé',
    'enseignant',
    'salarié',
    'stagiaire',
    'volontaire',
    'bénévole',
    'acteur',
    'chanteur',
    'auteur',
    'professeur',
    'lycée',
    'université',
    'café',
    'thé',
    'musée',
    'collège',
    'faculté',
    'école',
    'hôpital',
    'maison',
    'association',
]);
function isAcronymOrMixed(word) {
    const letters = word.replace(/[^a-zA-ZÀ-ÿ]/g, '');
    if (letters.length === 0)
        return false;
    const upper = letters.toUpperCase();
    const lower = letters.toLowerCase();
    if (upper === letters && letters.length <= 6)
        return true;
    if (letters === lower && letters.length <= 4)
        return false;
    return false;
}
function hasForbiddenCeePattern(word) {
    const lower = word.toLowerCase();
    if (lower.endsWith('ée')) {
        const stem = lower.slice(0, -2);
        if (stem.endsWith('c'))
            return true;
    }
    return false;
}
function feminizeWord(word) {
    if (!word || word.length < 2)
        return word;
    const lower = word.toLowerCase();
    if (FEMINIZE_BLOCKLIST.has(lower))
        return word;
    if (isAcronymOrMixed(word))
        return word;
    const rules = [
        [/(?<=\b\w{3,})en(?=\s|[,.;:!?]|$)/gi, 'enne'],
        [/(?<=\b\w{3,})eux(?=\s|[,.;:!?]|$)/gi, 'euse'],
        [/(?<=\b\w{3,})eur(?=\s|[,.;:!?]|$)/gi, 'euse'],
        [/(?<=\b\w{3,})if(?=\s|[,.;:!?]|$)/gi, 'ive'],
        [/(?<=\b\w{3,})f(?=\s|[,.;:!?]|$)/gi, 've'],
        [/(?<=\b\w{3,})é(?=\s|[,.;:!?]|$)/gi, 'ée'],
    ];
    let result = word;
    for (const [regex, replacement] of rules) {
        result = result.replace(regex, replacement);
    }
    return result;
}
function masculinizeWord(word) {
    if (!word || word.length < 2)
        return word;
    const lower = word.toLowerCase();
    if (MASCULINIZE_BLOCKLIST.has(lower))
        return word;
    if (isAcronymOrMixed(word))
        return word;
    if (hasForbiddenCeePattern(lower))
        return word;
    const rules = [
        [/(?<=\b\w{3,})enne(?=\s|[,.;:!?]|$)/gi, 'en'],
        [/(?<=\b\w{3,})euse(?=\s|[,.;:!?]|$)/gi, 'eur'],
        [/(?<=\b\w{3,})ive(?=\s|[,.;:!?]|$)/gi, 'if'],
        [/(?<=\b\w{3,})ve(?=\s|[,.;:!?]|$)/gi, 'f'],
        [/(?<=\b\w{3,})ée(?=\s|[,.;:!?]|$)/gi, 'é'],
    ];
    let result = word;
    for (const [regex, replacement] of rules) {
        result = result.replace(regex, replacement);
    }
    return result;
}
function genderizeText(text, gender) {
    if (text == null || !gender)
        return text;
    if (gender === 'femme')
        return feminizeText(text);
    if (gender === 'homme')
        return masculinizeText(text);
    return text;
}
function feminizeText(text) {
    if (text == null)
        return text;
    return text
        .split(/(\s+)/)
        .map(part => (/\S/.test(part) ? feminizeWord(part) : part))
        .join('');
}
function masculinizeText(text) {
    if (text == null)
        return text;
    return text
        .split(/(\s+)/)
        .map(part => (/\S/.test(part) ? masculinizeWord(part) : part))
        .join('');
}
